import { useState } from 'react';

interface ContactFormData {
  name: string;
  email: string;
  phone?: string;
  interest?: string;
  message: string;
}

interface SubmitResult {
  success: boolean;
  error?: string;
}

const API_ENDPOINT = 'https://bkkrbc6n79.execute-api.us-east-1.amazonaws.com/contact';

export function useContactForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitForm = async (data: ContactFormData): Promise<SubmitResult> => {
    setIsSubmitting(true);

    try {
      const response = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (!response.ok) {
        return { success: false, error: result.error || 'Failed to submit form' };
      }

      return { success: true };
    } catch (error) {
      console.error('Contact form error:', error);
      return {
        success: false,
        error: 'Network error. Please try again or call us at (651) 400-0063.',
      };
    } finally {
      setIsSubmitting(false);
    }
  };

  return { submitForm, isSubmitting };
}
